import PortfolioAllocationsTable from './CCPortfolioAllocationsTable'

export default PortfolioAllocationsTable
